// Shared constants and empty-state factories for the CRM modules.
export const CONTACT_GROUPS = ["All", "Vendors", "Subscriber", "Advertiser", "Friend", "Family", "Colleague", "Custom", "Other"];
export const EVENT_COLORS = ["#A3E635", "#3B82F6", "#EF4444", "#F59E0B", "#8B5CF6", "#EC4899", "#14B8A6", "#F97316"];
export const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export function emptyContact() {
  return {
    group: "Custom", first_name: "", last_name: "", photo_url: "",
    emails: [{ type: "work", email: "" }],
    phones: [{ type: "mobile", number: "" }],
    company: "", job_title: "", website: "",
    social: { twitter: "", linkedin: "", facebook: "", instagram: "" },
    relationships: { spouse: "", partner: "" },
    education: "", birthdate: "", organization: "",
    addresses: [{ type: "home", street: "", city: "", state: "", zip: "", country: "" }],
    notes: "", attachments: []
  };
}

export function emptyEvent() {
  const now = new Date();
  const start = now.toISOString().slice(0, 16);
  const end = new Date(now.getTime() + 3600000).toISOString().slice(0, 16);
  return { title: "", description: "", start_time: start, end_time: end, all_day: false, color: "#A3E635", location: "", reminder_minutes: 15 };
}
